/**
 * The browser tab names the surface (`studio/10`).
 *
 * One hook: the parts, joined with ` · `, ending in *Atlas Nook Studio* — the design files'
 * own `<title>` shape (*Your library · Atlas Nook Studio*). A story's surfaces lead with the
 * story's title. On unmount the tab falls back to the bare name, so a surface that sets no
 * title never inherits the last one's.
 *
 * `DocumentTitle` is the same thing as an element, for a surface whose title is known only
 * after its early returns — a hook there would run conditionally.
 */

import { useEffect } from 'react';
import type { JSX } from 'react';

export const STUDIO_NAME = 'Atlas Nook Studio';

export function documentTitle(parts: readonly (string | undefined)[]): string {
  return [
    ...parts.filter((part): part is string => part !== undefined && part !== ''),
    STUDIO_NAME,
  ].join(' · ');
}

export function useDocumentTitle(parts: readonly (string | undefined)[]): void {
  const title = documentTitle(parts);
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = STUDIO_NAME;
    };
  }, [title]);
}

export function DocumentTitle({ parts }: { parts: readonly (string | undefined)[] }): JSX.Element {
  useDocumentTitle(parts);
  return <></>;
}
